/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   10/14/21
 */

import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {persistState} from "../helpers";

export interface Preferences {
	theme: "light" | "dark" | null
}

const defaultState: Preferences = {
	theme: null
}

const STORAGE_KEY = "vega.state.preferences";
const storedState = localStorage.getItem(STORAGE_KEY);
const initialState: Preferences = {
	...defaultState,
	...(storedState ? JSON.parse(storedState) : {})
}

export const slice = createSlice({
	name: 'preferences',
	initialState,
	reducers: {
		set: (state, action: PayloadAction<Partial<Preferences>>) => {
			const newState = { ...state, ...action.payload };
			persistState(STORAGE_KEY, newState);
			return newState;
		},
	},
});

export const {set} = slice.actions;
export default slice.reducer;